import { Component, Injector, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BaseEntityComponent, BaseEntityConfig, BnLoadingService, EntityOrderedRequestParameters, EntityPagedResult, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { ValidacaoScr, SolicitacaoHonraValidacaoScr, SolicitacaoHonraValidacaoArquivoScr } from 'src/app/model/validacao-scr.model';
import { TIPOS_VALIDACAO_ARQ_SCR} from 'src/app/model/validacao-scr.model';
import Utils from 'src/app/shared/fgi-utils';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { ValidacaoScrService } from './validacao-scr.service';
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';
import { ActivatedRoute } from '@angular/router';
import { SolicitacaoHonra } from 'src/app/model/solicitacao-honra.model';

@Component({
    selector: 'app-validacao-scr-detalhe',
    templateUrl: './validacao-scr-detalhe.component.html',
    styleUrls: ['./validacao-scr-detalhe.component.scss'],
    standalone: false
})
export class ValidacaoScrDetalheComponent  extends BaseEntityComponent<ValidacaoScr> implements OnInit {
  
    tiposValidacaoScr = TIPOS_VALIDACAO_ARQ_SCR;   
    podeVisualizarValidacoes: boolean;
    private agentesFinanceiros: AgenteFinanceiro[] = [];

    private idValidacaoScr: number;
    private validacoesShScrBuscadas: SolicitacaoHonraValidacaoScr[];
    private validacoesShScrFiltradas:SolicitacaoHonraValidacaoScr[];
    private exibirApenasComErro = true;
    private arquivosShScr: SolicitacaoHonraValidacaoArquivoScr[];
    private errosValidacaoScr: OcorrenciaValidacaoVO[];
    private atributosPaginacaoSolicitacoesListagem: EntityPagedResult<SolicitacaoHonra>;
    private opcoesPaginacao: number[];
    private pesquisado: boolean;
    private totalObjetosRetornados: number;
    private idExternoOperacao: string;
    private contrato: string;

    public atributosOrdenacao: EntityOrderedRequestParameters;

    @ViewChild('arquivosScr') arquivosScrTemplateView: TemplateRef<any>;
    @ViewChild('errosValidacao') errosValidacaoTemplateView: TemplateRef<any>;
    @ViewChild('botoesAcao') botoesAcaoTemplateView: TemplateRef<any>;

    @Input() validacaoScr: ValidacaoScr;


    constructor(
        protected injector: Injector,
        protected service: ValidacaoScrService,
        private modalService: BnModalMessageService,
        private loadingService: BnLoadingService,
        private activatedRoute: ActivatedRoute) {
        super(service);
    }

    ngOnInit() {
       // this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
        //    this.podeVisualizarValidacoes = resp && resp[ROLE_GESTOR_CONSULTA];
       // });

        this.setAtributoPaginacao()
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; // resolver

            this.route.params.subscribe(params => {
                this.idValidacaoScr = params['id'];
                this.buscarValidacaoDetalhe();
                this.buscarSolicitacoesHonraValidacao(false, true);
            });
    }  

    public buscarValidacaoDetalhe(){
        
        this.service.getValidacaoScr(this.idValidacaoScr).subscribe(resp =>{
            this.validacaoScr = resp;
        })   
    }
    public buscarSolicitacoesHonraValidacao (paginaVazia: boolean, voltarPagina1: boolean){
        this.loadingService.bloqueiaTela();
        this.pesquisado = false;

        const params: any = {};
        
        if(voltarPagina1){
            this.atributosPaginacaoSolicitacoesListagem.page = 1;
        }
            
        paginaVazia = Utils.verificaPaginaVazia(this.validacoesShScrBuscadas, this.atributosPaginacaoSolicitacoesListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
            this.atributosPaginacaoSolicitacoesListagem.page = this.atributosPaginacaoSolicitacoesListagem.pages;
        }

        params.apenasComErro = this.exibirApenasComErro;
        if (this.idExternoOperacao) {
            params.idExternoOperacao = this.idExternoOperacao;
        }
        if (this.contrato) {
            params.contrato = this.contrato;
        }
        params.pagina = this.atributosPaginacaoSolicitacoesListagem.page;
        params.limite = this.atributosPaginacaoSolicitacoesListagem.pageSize;

        this.service.getSolicitacoesHonraValidacaoScr(this.idValidacaoScr, params).subscribe(resp => {
            this.validacoesShScrBuscadas = resp.resultados;
            this.atributosPaginacaoSolicitacoesListagem.count = resp ? resp.totalRegistrosSemPaginacao : 0;
            this.totalObjetosRetornados = this.atributosPaginacaoSolicitacoesListagem.count;
            this.ordenarPorIdDescrescente();
            
            this.loadingService.liberaTela();
            this.pesquisado = true;
             
            paginaVazia = Utils.verificaPaginaVazia(this.validacoesShScrBuscadas, this.atributosPaginacaoSolicitacoesListagem, this.totalObjetosRetornados);
            if (paginaVazia && !voltarPagina1) {
                this.buscarSolicitacoesHonraValidacao(false, true);
            }

        });
    }

    public setAtributoPaginacao(){
        this.opcoesPaginacao = [10, 15, 20];
        this.atributosPaginacaoSolicitacoesListagem = {
        page: 1,
        pageSize: this.opcoesPaginacao[0],
        pages: undefined,
        count: undefined,
        list: undefined
        };
    }

    mudancaPagina(novaPagina: EntityPagedResult<SolicitacaoHonra>) {
        this.atributosPaginacaoSolicitacoesListagem = novaPagina;
        this.buscarSolicitacoesHonraValidacao(false, false);
        
    }

    ordenarPorIdDescrescente(){
        this.validacoesShScrBuscadas = this.validacoesShScrBuscadas.sort((a, b) => {
          return -1 * Utils.comparaComFuncao(a, b, 'idSolicitacaoHonra', parseFloat);
        });
      }
    
    /*
    visualizarOperacao(solicitacaoHonraArquivo:SolicitacaoHonraArquivoSCR){
        const modalRef = this._modalService.open(ArquivoPopupComponent, {
            windowClass: 'modal-dialog-xl',
            backdrop: 'static'
          });
    
        modalRef.componentInstance.solicitacaoHonraArquivo = solicitacaoHonraArquivo;
    }
    */
   
    private labelTipoValidacaoScr(codigo: string): string {
        return this.tiposValidacaoScr.find(tipo => tipo.codigo === codigo).label;
    }

    exibirPopupComArquivosScr(idSolicitacaoHonra) {

        this.loadingService.bloqueiaTela();

        this.service.getArquivoScrUtilizadoNaValidacao(this.idValidacaoScr, idSolicitacaoHonra)
            .subscribe(arquivosShScr => {
                this.arquivosShScr = arquivosShScr;
                this.loadingService.liberaTela();
                this.modalService
                    .abrir("Arquivos SCR", null, 'lg', this.arquivosScrTemplateView, this.botoesAcaoTemplateView);

            }, error => {
                console.log(error);
                this.loadingService.liberaTela();
            });
    }

    exibirPopupComErros(idSolicitacaoHonra) {
        this.loadingService.bloqueiaTela();

        this.service.getErrosDeValidacao(this.idValidacaoScr, idSolicitacaoHonra)
            .subscribe(errosValidacaoScr => {
                
                this.errosValidacaoScr = errosValidacaoScr;
                this.loadingService.liberaTela();
                this.modalService
                    .abrir("Erros encontrados na validação", null, 'lg', this.errosValidacaoTemplateView, this.botoesAcaoTemplateView);

            }, error => {
                console.log(error);
                this.loadingService.liberaTela();
            });
    }

    fecharPopup() {
        this.modalService.dismiss('');
    }    

    private nomeAgente(cnpj: string) {
        return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
    }

    checkBoxChanged(event) {
        this.buscarSolicitacoesHonraValidacao(false, true);
    }

    inputTextChanged(event) {
        this.buscarSolicitacoesHonraValidacao(false, true);
    }

    voltarParaLista() {
        this.router.navigate(['/validacoes-scr/pesquisa']);
    }

    mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
        this.atributosOrdenacao = novaOrdenacao;
        this.pesquisarOrdenacao(this.atributosOrdenacao);
    }

    nomeJanelaOrdenavel(nomeJanela: string) {
        if (nomeJanela && nomeJanela.length == 7) {
            return nomeJanela.substring(3, 7) + "/" + nomeJanela.substring(0, 2);
        }
        return nomeJanela;
    }

    pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
        let funcao = undefined;
        if (ord.atributo == 'nomeJanela') {
            funcao = (s) => this.nomeJanelaOrdenavel(s);
        }
        else if (ord.atributo == 'cnpjAgenteFinanceiro') {
            funcao = (s) => this.nomeAgente(s);
        }
        else if (ord.atributo == 'self') {
            funcao = (s) => s.idOperacaoAgenteCreditoLivre ? s.idOperacaoAgenteCreditoLivre : s.contratoRepasse.toString();
        }
        else if (ord.atributo == 'possuiErrosDeValidacao') {
            funcao = (s) => s ? "Não" : "Sim";
        }
        else if (ord.atributo == 'validacaoIndicioRecuperacaoCredito') {
            funcao = (s) => s.valorTotalDividaMesAtual - s.valorTotalDividaMesAnterior;
        }

        this.validacoesShScrBuscadas = this.validacoesShScrBuscadas.sort((a, b) => {
            if (ord.sentido == "asc") {
            return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
            }
            else {
            return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
            }
        });
    }
}